import { useState, useEffect } from 'react';

import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

import {
  pailingFrontC8,
  pailingFrontC21,
  pailingFrontMP20,
  pailingBackC8,
  pailingBackC21,
  pailingBackMP20,
  picketFrontM,
  picketBackM
} from 'src/assets/images';

export const usePresenter = () => {
  const { dispatch, fenceStore } = useStoreon<IState, IEvents>('fenceStore');

  const fenceSideHandler = (checked: boolean) => {
    dispatch('fence/set-fence-side', { fenceSide: checked ? 'back' : 'front'  });
  };
  const fenceColorHandler = (fenceColor: string) => {
    dispatch('fence/set-fence-color', { fenceColor });
  };

  const [fenceImage, setFenceImage] = useState(pailingFrontC8);

  useEffect(() => {
    if (fenceStore.fenceType === 'pailing') {
      if (fenceStore.fenceSide === 'front') {
        switch (fenceStore.pailingType) {
          case 'С08':
            setFenceImage(pailingFrontC8);
            break;
          case 'С21':
            setFenceImage(pailingFrontC21);
            break;
          case 'МП20':
            setFenceImage(pailingFrontMP20);
            break;
          default:
            setFenceImage(pailingFrontC8);
        }
      }

      if (fenceStore.fenceSide === 'back') {
        switch (fenceStore.pailingType) {
          case 'С08':
            setFenceImage(pailingBackC8);
            break;
          case 'С21':
            setFenceImage(pailingBackC21);
            break;
          case 'МП20':
            setFenceImage(pailingBackMP20);
            break;
          default:
            setFenceImage(pailingBackC8);
        }
      }
    } else if (fenceStore.fenceType === 'picket') {
      if (fenceStore.fenceSide === 'front') {
        setFenceImage(picketFrontM);
      }
      if (fenceStore.fenceSide === 'back') {
        setFenceImage(picketBackM);
      }
    }
  }, [fenceStore.fenceType, fenceStore.fenceSide, fenceStore.pailingType]);

  return {
    fenceSide: fenceStore.fenceSide,
    fenceColor: fenceStore.fenceColor,
    fenceImage: fenceImage,

    fenceSideHandler,
    fenceColorHandler,
  };
};
